import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentService } from './environment.service';
import { PaginationRequest } from './models/pagination/pagination.request.model';
import { RequestHelper } from '@shared/helpers/request.helper';

@Injectable({ providedIn: 'root' })
export class GvTaTrackerAssignmentApiService {
    constructor(
        private httpClient: HttpClient,
        private environmentService: EnvironmentService
    ) {}

    private get url(): string {
        return `${this.environmentService.getCurrentApiUrl()}/gv-ta-tracker-assignments`;
    }

    getAssignments(req: PaginationRequest): Observable<any> {
        const options = RequestHelper.createRequestOption(req);
        return this.httpClient.get<any>(this.url, { params: options });
    }

    getTrackers(req: PaginationRequest): Observable<any> {
        const options = RequestHelper.createRequestOption(req);
        return this.httpClient.get<any>(`${this.url}/trackers`, { params: options });
    }

    getTrackerOptions(req: PaginationRequest, body?: any): Observable<any> {
        const options = RequestHelper.createRequestOption(req);
        return this.httpClient.post<any>(`${this.url}/trackers`, body || {}, { params: options });
    }

    getGvTaWithoutActiveAssignment(req: PaginationRequest): Observable<any> {
        const options = RequestHelper.createRequestOption(req);
        return this.httpClient.get<any>(`${this.url}/gv-ta-without-active-assignment`, { params: options });
    }

    assignGvTaToTracker(assignment: any): Observable<any> {
        return this.httpClient.post<any>(this.url, assignment);
    }

    updateAssignment(assignment: any): Observable<any> {
        return this.httpClient.put<any>(this.url, assignment);
    }

    endAssignment(id: string, data: any): Observable<any> {
        return this.httpClient.delete<any>(`${this.url}/${id}`, { body: data });
    }

    migrateAssignments(data: any): Observable<any> {
        return this.httpClient.post<any>(`${this.url}/migrate`, data);
    }

    reassignGvTaToTracker(data: any): Observable<any> {
        return this.httpClient.post<any>(`${this.url}/reassign`, data);
    }
}

